export const useDialogManager = () => {
  // 공통 상태
  const dialogTitle = ref('');
  const dialogTitleClass = ref(''); // [추가]
  const dialogTitle2 = ref('');
  const dialogTitle2Class = ref(''); // [추가]
  const dialogMessage = ref(''); // [추가]
  const dialogText = ref('');
  const dialogSubtitle = ref('');
  const dialogNextUrl = ref(null);
  const displayPoint = ref('');
  const dialogWarning = ref(''); // 경고 문구

  // [추가] 취소 버튼 커스텀
  const dialogCancelText = ref('취소');
  const dialogCancel = ref(null);

  // 각 dialog 컴포넌트 참조
  const alertRef = ref(null);
  const confirmRef = ref(null);
  const pointDialogRef = ref(null);

  // Alert: OK 버튼만 있는 알림창
  const showAlert = ({ title, titleClass = '', title2 = '', text, nextUrl = null }) => {
    dialogTitle.value = title;
    dialogTitleClass.value = titleClass;
    dialogTitle2.value = title2;
    dialogText.value = text;
    dialogNextUrl.value = nextUrl;
    dialogCancel.value = null;
    alertRef.value?.openAlertDialog();
  };

  // Confirm: OK/Cancel 있는 확인창
  const showConfirm = ({
    title,
    titleClass = '', // [추가]
    title2 = '',
    title2Class = '', // [추가]
    message = '', // [추가]
    text = '',
    onConfirm = () => {},
    cancelText = '취소', // [추가]
    onCancel = null, // [추가]
    warning = '', // 경고 문구
  }) => {
    dialogTitle.value = title;
    dialogTitleClass.value = titleClass; // [추가]
    dialogTitle2.value = title2;
    dialogTitle2Class.value = title2Class;
    dialogMessage.value = message; // [추가]
    dialogText.value = text;
    dialogNextUrl.value = onConfirm;
    dialogWarning.value = warning; // 경고 문구

    // [추가] 취소 옵션 설정
    dialogCancelText.value = cancelText;
    dialogCancel.value = onCancel;

    confirmRef.value?.openConfirmDialog();
  };

  // 포인트 결제 전용 Confirm Dialog
  const showPointDialog = ({
    title,
    subtitle,
    point,
    confirmText = '구매',
    onConfirm = () => {},
  }) => {
    dialogTitle.value = title;
    dialogSubtitle.value = subtitle;
    displayPoint.value = point;
    dialogText.value = confirmText;
    dialogNextUrl.value = onConfirm;
    pointDialogRef.value?.openConfirmDialog();
  };

  return {
    // 상태
    dialogTitle,
    dialogTitleClass,
    dialogTitle2,
    dialogTitle2Class,
    dialogMessage,
    dialogText,
    dialogSubtitle,
    dialogNextUrl,
    displayPoint,
    dialogWarning,
    dialogCancelText,
    dialogCancel,

    // 참조 ref
    alertRef,
    confirmRef,
    pointDialogRef,

    // 메서드
    showAlert,
    showConfirm,
    showPointDialog,
  };
};
